export const filterPreservingType = <T extends unknown[]>(
	array: T,
	predicate: (item: T[number]) => boolean | undefined,
): T => {
	return array.filter(predicate) as T
}
